import React from 'react';
import Book from './Book';
import Addbook from './Addbook';

function Books() {
	return (
  <div>
    <Book />
    <Addbook />
  </div>
	);
}

export default Books;
